// src/pages/Login.tsx
import React, { useState, ChangeEvent, FormEvent } from "react";
import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  IconButton,
  InputAdornment,
  Link,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../hooks/useAppStore";
import { useLoginMutation } from "../services/auth/authApi";
import { loginSuccess } from "../services/auth/authSlice";

const Login: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const [login, { isLoading }] = useLoginMutation();

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    try {
      const result = await login({ email: username, password }).unwrap();
      dispatch(loginSuccess(result?.user));
      navigate("/");
    } catch (error) {
      console.error("Error en el login:", error);
      alert("Error en el login (demo)");
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <Paper sx={{ padding: 4, maxWidth: 400, margin: "auto", mt: 8, mb: 4 }}>
      {/* Logo de la empresa */}
      <Box sx={{ textAlign: "center", mb: 2 }}>
        <img
          src={"/flobinar.png"}
          alt="Logo de la empresa"
          style={{ width: "60px", height: "auto" }}
        />
      </Box>
      <Typography variant="h5" align="center" gutterBottom>
        Iniciar Sesión
      </Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          label="Email"
          variant="outlined"
          fullWidth
          margin="normal"
          value={username}
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            setUsername(e.target.value)
          }
          required
          sx={{ mb: 2 }}
        />
        <TextField
          label="Contraseña"
          variant="outlined"
          type={showPassword ? "text" : "password"}
          fullWidth
          margin="normal"
          value={password}
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            setPassword(e.target.value)
          }
          required
          sx={{ mb: 2 }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={togglePasswordVisibility}
                  edge="end"
                  aria-label="toggle password visibility"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <Box sx={{ textAlign: "right", mb: 2 }}>
          <Link href="/forgot-password" variant="body2">
            ¿Olvidaste tu contraseña?
          </Link>
        </Box>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          fullWidth
          sx={{ mt: 2, mb: 2 }}
        >
          {isLoading ? "Cargando..." : "Iniciar Sesión"}
        </Button>
        <Box sx={{ textAlign: "center", mt: 2 }}>
          <Typography variant="body2" color="text.secondary">
            ¿Necesitas ayuda?
          </Typography>
          <Link href="mailto:soporte@tuempresa.com" variant="body2">
            Contactar Soporte
          </Link>
        </Box>
      </form>
    </Paper>
  );
};

export default Login;
